module.exports = __webpack_public_path__ + "412c1ca4eaf35569306c78754ae68f03.svg";